import React from 'react';
import PropTypes from 'prop-types';
import SurflineFooter from '@surfline/quiver-react/dist/SurflineFooter';
import entitlementsPropType from '@surfline/quiver-react/dist/PropTypes/entitlementsPropType';

const Footer = ({ entitlements }) => (
  <SurflineFooter entitlements={entitlements ? entitlements.entitlements : []} />
);

Footer.propTypes = {
  entitlements: PropTypes.shape({
    entitlements: entitlementsPropType,
  }),
};

Footer.defaultProps = { entitlements: [] };

export default Footer;



// WEBPACK FOOTER //
// ./src/bundles/margins/Footer.js